var acc = document.getElementsByClassName("b-accordeon__button");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    var panel = this.parentNode;
    if (panel.classList.contains('active')) { 
      panel.classList.remove("active");
    } else {
      panel.classList.add('active');
    }
  });
}



var accMenu = document.getElementsByClassName("b-menu-header__accbutton");
var i;
for (i = 0; i < accMenu.length; i++) {
  accMenu[i].addEventListener("click", function() {
    var panel = this.parentNode;
    if (panel.classList.contains('active')) { 
      panel.classList.remove("active");
    } else {
      panel.classList.add('active');
    }
  });
}




// WEBPACK FOOTER //
// ./src/js/pages/oneevent/accordeon.js